

export enum UserTabLoadMode {
	USER_LIST_ONLY = 'USER_LIST_ONLY',
	ALL_DATA = 'ALL_DATA'
}


